class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.fullCartElement = document.querySelector('#cart-notification-full-cart');
    this.treatProductsPromise = null;

    // The discount is read dynamically as a decimal rate from
    // window.multibuyDiscountPercent whenever the basket is rendered.
    // Example: 0.10 displays as 10%.

    this.ensureCartStyles();
    this.makeBasketHeadingProminent();

    if (this.notification) {
      this.notification.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close()
      );
    }

    this.querySelectorAll('[data-cart-notification-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.addEventListener('click', this.onCartNotificationClick.bind(this));
    this.addEventListener('change', this.onCartNotificationChange.bind(this));
    document.addEventListener(
      'cart:refresh',
      this.renderFullCartNotification.bind(this)
    );
  }

  ensureCartStyles() {
    if (document.querySelector('[data-pcd-cart-cross-sell-styles]')) return;

    const style = document.createElement('style');
    style.setAttribute('data-pcd-cart-cross-sell-styles', '');
    style.textContent = `
      .pcd-cart-heading {
        margin: 0 0 14px !important;
        color: #111827 !important;
        font-size: clamp(26px, 7vw, 38px) !important;
        font-weight: 900 !important;
        letter-spacing: -0.035em !important;
        line-height: 1 !important;
        text-transform: uppercase !important;
      }

      .pcd-delivery-line {
        display: grid;
        grid-template-columns: 42px minmax(0, 1fr) auto;
        align-items: center;
        gap: 10px;
        margin-top: 14px;
        padding: 14px 0 2px;
        border-top: 1px solid #e5e7eb;
      }

      .pcd-delivery-line__icon {
        display: grid;
        width: 38px;
        height: 38px;
        place-items: center;
        border-radius: 999px;
        background: #eaf8ee;
        color: #15803d;
        font-size: 20px;
      }

      .pcd-delivery-line__label {
        color: #111827;
        font-size: 12px;
        font-weight: 750;
        line-height: 1.25;
      }

      .pcd-delivery-line__price {
        display: flex;
        align-items: baseline;
        justify-content: flex-end;
        gap: 8px;
        white-space: nowrap;
        font-size: 12px;
      }

      .pcd-delivery-line__price s {
        color: #6b7280;
      }

      .pcd-delivery-line__free {
        color: #15803d;
        font-weight: 900;
      }

      .pcd-multibuy-panel {
        margin-top: 18px;
        padding: 16px;
        border: 1px solid #8fd0a1;
        border-radius: 14px;
        background: #fbfffc;
      }

      .pcd-multibuy-panel__title {
        margin: 0;
        color: #111827;
        font-size: 19px;
        font-weight: 900;
        letter-spacing: -0.02em;
        line-height: 1.15;
      }

      .pcd-multibuy-panel__progress-row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: center;
        gap: 10px;
        margin-top: 12px;
      }

      .pcd-multibuy-panel__track {
        width: 100%;
        height: 12px;
        overflow: hidden;
        border-radius: 999px;
        background: #e5e7eb;
      }

      .pcd-multibuy-panel__fill {
        display: block;
        height: 100%;
        border-radius: inherit;
        background: #16a34a;
        transition: width 180ms ease;
      }

      .pcd-multibuy-panel__remaining {
        color: #15803d;
        font-size: 13px;
        font-weight: 850;
        white-space: nowrap;
      }

      .pcd-multibuy-panel__saving {
        margin: 12px 0 0;
        color: #111827;
        font-size: 16px;
        line-height: 1.35;
      }

      .pcd-multibuy-panel__saving strong {
        color: #15803d;
      }

      .pcd-cross-sell-intro {
        margin: 18px 4px 12px;
        color: #252525;
        font-size: 15px;
        line-height: 1.35;
        text-align: center;
      }

      .pcd-treat-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        align-items: start;
        gap: 10px;
      }

      .pcd-treat-card {
        display: flex;
        min-width: 0;
        height: fit-content;
        align-self: start;
        flex-direction: column;
        padding: 10px;
        border: 1px solid #e7e7e7;
        border-radius: 13px;
        background: #fff;
        box-shadow: 0 2px 10px rgba(17, 24, 39, 0.05);
      }

      .pcd-treat-card__image-link {
        display: block;
        height: 112px;
        margin-bottom: 7px;
        text-align: center;
      }

      .pcd-treat-card__image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .pcd-treat-card__function {
        margin: 0;
        color: #111827;
        font-size: 15px;
        font-weight: 900;
        letter-spacing: -0.01em;
        line-height: 1.18;
      }

      .pcd-treat-card__synopsis {
        display: -webkit-box;
        min-height: 48px;
        margin: 7px 0 10px;
        overflow: hidden;
        color: #1f2937;
        font-size: 13px;
        line-height: 1.35;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }

      .pcd-treat-card__synopsis > :first-child {
        margin-top: 0;
      }

      .pcd-treat-card__synopsis > :last-child {
        margin-bottom: 0;
      }

      .pcd-treat-card__split-button {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 68px;
        width: 100%;
        height: 42px;
        min-height: 42px;
        margin-top: 3px;
        overflow: hidden;
        border: 1.5px solid #16a34a;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 2px 0 rgba(21, 128, 61, 0.10);
        transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
      }

      .pcd-treat-card__split-button:hover {
        border-color: #15803d;
        box-shadow: 0 3px 8px rgba(21, 128, 61, 0.14);
      }

      .pcd-treat-card__split-button:focus-within {
        outline: 3px solid rgba(22, 163, 74, 0.18);
        outline-offset: 2px;
      }

      .pcd-treat-card__button {
        display: flex;
        width: 100%;
        height: 100%;
        min-width: 0;
        align-items: center;
        justify-content: center;
        padding: 4px 3px;
        border: 0;
        background: #fff;
        color: #15803d;
        cursor: pointer;
        font: inherit;
        font-size: 11px;
        font-weight: 900;
        letter-spacing: -0.01em;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        transition: background 150ms ease;
      }

      .pcd-treat-card__button:hover {
        background: #f2fbf4;
      }

      .pcd-treat-card__flavour {
        position: relative;
        display: flex;
        width: 68px;
        min-width: 68px;
        height: 100%;
        align-items: stretch;
        border-left: 1px solid #9bd8aa;
        background: #f2fbf4;
      }

      .pcd-treat-card__flavour::after {
        content: '⌄';
        position: absolute;
        top: 50%;
        right: 5px;
        color: currentColor;
        font-size: 12px;
        font-weight: 900;
        line-height: 1;
        pointer-events: none;
        transform: translateY(-58%);
      }

      .pcd-treat-card__flavour-select {
        display: block;
        width: 100%;
        height: 100%;
        min-width: 0;
        padding: 0 18px 0 6px;
        border: 0;
        border-radius: 0;
        outline: 0;
        appearance: none;
        background: transparent;
        color: #166534;
        cursor: pointer;
        font: inherit;
        font-size: 10px;
        font-weight: 850;
        line-height: 1.1;
        text-align: left;
        text-align-last: left;
        white-space: nowrap;
      }

      .pcd-treat-card__split-button--primary {
        border-color: #15803d;
        background: #16a34a;
        box-shadow: 0 3px 8px rgba(21, 128, 61, 0.22);
      }

      .pcd-treat-card__split-button--primary .pcd-treat-card__button {
        background: #16a34a;
        color: #fff;
      }

      .pcd-treat-card__split-button--primary .pcd-treat-card__button:hover {
        background: #15803d;
      }

      .pcd-treat-card__split-button--primary .pcd-treat-card__flavour {
        border-left-color: rgba(255, 255, 255, 0.45);
        background: #12833a;
        color: #fff;
      }

      .pcd-treat-card__split-button--primary .pcd-treat-card__flavour-select {
        color: #fff;
      }

      .pcd-treat-card__flavour-select option {
        background: #fff;
        color: #111827;
      }

      .pcd-treat-card__button[disabled] {
        cursor: wait;
        opacity: 0.65;
      }

      .pcd-treat-card__details {
        margin-top: 7px;
        border-top: 1px solid #ededed;
      }

      .pcd-treat-card__details summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
        min-height: 38px;
        padding: 7px 2px 0;
        color: #111827;
        cursor: pointer;
        font-size: 12.5px;
        font-weight: 700;
        list-style: none;
      }

      .pcd-treat-card__details summary::-webkit-details-marker {
        display: none;
      }

      .pcd-treat-card__details summary::before {
        content: 'ⓘ';
        flex: 0 0 auto;
        font-size: 16px;
      }

      .pcd-treat-card__details summary::after {
        content: '⌄';
        margin-left: auto;
        font-size: 17px;
        line-height: 1;
        transition: transform 150ms ease;
      }

      .pcd-treat-card__details[open] summary::after {
        transform: rotate(180deg);
      }

      .pcd-treat-card__details-content {
        padding: 8px 2px 4px;
        color: #4b5563;
        font-size: 12px;
        line-height: 1.4;
      }

      .pcd-cross-sell-error {
        margin: 14px 0 0;
        color: #6b7280;
        font-size: 13px;
        text-align: center;
      }

      @media (max-width: 360px) {
        .pcd-treat-grid {
          gap: 8px;
        }

        .pcd-treat-card {
          padding: 8px;
        }

        .pcd-treat-card__image-link {
          height: 96px;
        }

        .pcd-treat-card__split-button {
          grid-template-columns: minmax(0, 1fr) 64px;
          height: 42px;
          min-height: 42px;
        }

        .pcd-treat-card__button {
          padding-inline: 2px;
          font-size: 10px;
        }

        .pcd-treat-card__flavour {
          width: 64px;
          min-width: 64px;
        }

        .pcd-treat-card__flavour-select {
          padding-right: 16px;
          padding-left: 5px;
          font-size: 9.5px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  makeBasketHeadingProminent() {
    if (!this.notification) return;

    const heading = this.notification.querySelector(
      '[data-cart-notification-heading], .cart-notification__heading, .cart-notification__header h2'
    );

    if (heading) {
      heading.classList.add('pcd-cart-heading');
    }
  }

  setLineLoading(line, isLoading) {
    const priceElement = this.querySelector(`[data-line-price="${line}"]`);
    if (!priceElement) return;

    const priceText = priceElement.querySelector('[data-line-price-text]');
    const spinner = priceElement.querySelector('[data-line-price-spinner]');

    if (priceText) {
      priceText.classList.toggle('hidden', isLoading);
    }

    if (spinner) {
      spinner.classList.toggle('hidden', !isLoading);
    }
  }

  onSubmitHandler() {
    const submitButton = this.querySelector('[type="submit"]');
    if (!submitButton) return;

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');

    const spinner = this.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');
  }

  getCartScrollContainers() {
    if (!this.notification) return [];

    const containers = new Set([
      this.notification,
      this.fullCartElement,
      this.fullCartElement?.parentElement,
      this.notification.querySelector('.cart-notification__wrapper'),
      this.notification.querySelector('.cart-notification__inner'),
      this.notification.querySelector('.cart-notification__content'),
      this.notification.querySelector('[data-cart-notification-scroll]')
    ].filter(Boolean));

    // Theme markup varies. Include any genuinely scrollable descendants so
    // Firefox or the browser's history restoration cannot reopen the drawer
    // at its previous scroll position.
    this.notification.querySelectorAll('*').forEach((element) => {
      const styles = window.getComputedStyle(element);
      const overflowY = styles.overflowY;

      if (
        ['auto', 'scroll', 'overlay'].includes(overflowY) &&
        element.scrollHeight > element.clientHeight
      ) {
        containers.add(element);
      }
    });

    return [...containers];
  }

  resetCartScrollPosition() {
    this.getCartScrollContainers().forEach((element) => {
      element.scrollTop = 0;
      element.scrollLeft = 0;

      if (typeof element.scrollTo === 'function') {
        try {
          element.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto'
          });
        } catch (_) {
          element.scrollTo(0, 0);
        }
      }
    });
  }

  open() {
    if (!this.notification) return;

    // Reset immediately, then again after the drawer becomes visible and the
    // browser has completed layout. This also defeats restored scrollTop on
    // a page reload.
    this.resetCartScrollPosition();
    this.notification.classList.add('animate', 'active');

    requestAnimationFrame(() => {
      this.resetCartScrollPosition();

      requestAnimationFrame(() => {
        this.resetCartScrollPosition();
      });
    });

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.resetCartScrollPosition();
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    // Keep the chat bubble from competing with the basket.
    const chat = document.getElementById('shopify-chat');
    if (chat) chat.style.display = 'none';

    await this.renderFullCartNotification(parsedState);
  }

  async renderFullCartNotification(parsedState) {
    const cart = await this.renderFullCartItems();
    if (cart) this.updatePriceElements(cart);

    this.renderBundledSections(parsedState, [
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-notification-button',
        selector: '.shopify-section'
      }
    ]);

    if (this.header) this.header.reveal();

    this.open();
  }

  renderBundledSections(parsedState, sections) {
    if (!parsedState || !parsedState.sections) return;

    sections.forEach((section) => {
      const html = parsedState.sections[section.id];
      const target = document.getElementById(section.id);

      if (!html || !target) return;

      target.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });
  }

  async renderFullCartItems(cartOverride = null) {
    const cart = cartOverride || await this.fetchCart();

    if (!this.fullCartElement) return cart;

    if (!cart.items || cart.items.length === 0) {
      this.fullCartElement.innerHTML = `
        <p class="cart-notification-full-cart__empty">Your cart is empty.</p>
        <button type="button" class="link button-label" style="margin-top: 24px;">
          Hide basket and carry on shopping
        </button>
      `;

      const hideButton = this.fullCartElement.querySelector('button');
      if (hideButton) {
        hideButton.addEventListener('click', this.close.bind(this));
      }

      return cart;
    }

    const cartItemsHtml = cart.items.map((item, index) => {
      const image = item.image
        ? `<img src="${this.escapeHtml(this.resizeImageUrl(item.image, 144))}" alt="${this.escapeHtml(item.product_title)}" loading="lazy">`
        : '';

      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cart-notification-full-cart__variant">${this.escapeHtml(item.variant_title)}</div>`
        : '';

      const hasDiscount = Number(item.line_price) !== Number(item.original_line_price);

      const priceHtml = hasDiscount
        ? `
          <span class="cart-notification-full-cart__compare-price">
            <s>${this.formatMoney(item.original_line_price)}</s>
          </span>
          <span class="cart-notification-full-cart__sale-price">
            ${this.formatMoney(item.line_price)}
          </span>
        `
        : `
          <span class="cart-notification-full-cart__sale-price">
            ${this.formatMoney(item.line_price)}
          </span>
        `;

      return `
        <div class="cart-notification-full-cart__item" data-cart-line="${index + 1}" data-cart-key="${this.escapeHtml(item.key)}">
          <div class="cart-notification-full-cart__image">
            ${image}
          </div>

          <div>
            <div class="cart-notification-full-cart__title">
              ${this.escapeHtml(item.product_title)}
            </div>

            ${variantTitle}

            <div class="cart-notification-full-cart__row">
              <div class="cart-notification-full-cart__qty" aria-label="Quantity selector">
                <button
                  type="button"
                  data-cart-qty-minus
                  data-line="${index + 1}"
                  data-quantity="${item.quantity - 1}"
                  aria-label="Decrease quantity of ${this.escapeHtml(item.product_title)}"
                >
                  −
                </button>

                <span>${item.quantity}</span>

                <button
                  type="button"
                  data-cart-qty-plus
                  data-line="${index + 1}"
                  data-quantity="${item.quantity + 1}"
                  aria-label="Increase quantity of ${this.escapeHtml(item.product_title)}"
                >
                  +
                </button>
              </div>

              <div class="cart-notification-full-cart__price" data-line-price="${index + 1}">
                <span data-line-price-text>
                  ${priceHtml}
                </span>

                <span class="cart-notification-full-cart__line-spinner hidden" data-line-price-spinner>
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');

    let treatProducts = [];
    let treatProductsError = null;

    try {
      treatProducts = await this.fetchTreatProducts();
    } catch (error) {
      treatProductsError = error;
      console.error('Failed to load dog treat cross-sells', error);
    }

    this.fullCartElement.innerHTML = `
      ${cartItemsHtml}
      ${this.renderDeliveryLine(cart)}
      ${this.renderMultibuyPanel(cart, treatProducts)}
      ${treatProductsError
        ? '<p class="pcd-cross-sell-error">Treat recommendations could not be loaded.</p>'
        : this.renderTreatCrossSells(cart, treatProducts)}
    `;

    return cart;
  }

  renderDeliveryLine(cart) {
    const freeShippingThreshold = 1599; // £15.99
    const deliveryPrice = 340;
    const cartTotal = Number(cart.total_price) || 0;
    const hasFreeDelivery = cartTotal >= freeShippingThreshold;

    if (hasFreeDelivery) {
      return `
        <div class="pcd-delivery-line" aria-label="Delivery">
          <span class="pcd-delivery-line__icon" aria-hidden="true">🚚</span>
          <span class="pcd-delivery-line__label">2-day Royal Mail delivery</span>
          <span class="pcd-delivery-line__price">
            <span class="pcd-delivery-line__free">FREE</span>
          </span>
        </div>
      `;
    }

    const remaining = Math.max(freeShippingThreshold - cartTotal, 0);

    return `
      <div class="pcd-delivery-line" aria-label="Delivery">
        <span class="pcd-delivery-line__icon" aria-hidden="true">🚚</span>
        <span class="pcd-delivery-line__label">
          2-day Royal Mail delivery<br>
          <small>Spend ${this.formatMoney(remaining)} more for FREE delivery</small>
        </span>
        <span class="pcd-delivery-line__price">
          ${this.formatMoney(deliveryPrice)}
        </span>
      </div>
    `;
  }

  renderMultibuyPanel(cart, products = []) {
    const treatsCount = this.getTreatCount(cart);
    const prospectiveSavingCents = this.getProspectiveMultibuySavingCents(cart, products);
    const hasUnlockedMultibuy = treatsCount >= 2;
    const discountLabel = this.getMultibuyDiscountLabel();

    let title;
    let remainingLabel;
    let savingMessage;
    let visualProgress;

    if (treatsCount === 0) {
      title = discountLabel
        ? `Add 2 jars to unlock ${discountLabel} off`
        : 'Add 2 jars to unlock the multibuy discount';
      remainingLabel = '2 more to go';
      savingMessage = prospectiveSavingCents === null
        ? 'Add any 2 jars to unlock the multibuy discount'
        : `Add any 2 jars and save <strong>${this.formatMoney(prospectiveSavingCents)}</strong> on this order`;
      visualProgress = 0;
    } else if (hasUnlockedMultibuy) {
      title = discountLabel
        ? `${discountLabel} multibuy discount unlocked`
        : 'Multibuy discount unlocked';
      remainingLabel = 'Unlocked';
      savingMessage = '<strong>Your multibuy discount is now active.</strong>';
      visualProgress = 100;
    } else {
      title = discountLabel
        ? `Add 1 more jar to unlock ${discountLabel} off`
        : 'Add 1 more jar to unlock the multibuy discount';
      remainingLabel = 'Just 1 more to go';
      savingMessage = prospectiveSavingCents === null
        ? 'Add any jar to unlock the multibuy discount'
        : `Add any jar and save <strong>${this.formatMoney(prospectiveSavingCents)}</strong> on this order`;
      visualProgress = 90;
    }

    return `
      <section class="pcd-multibuy-panel" aria-live="polite">
        <h3 class="pcd-multibuy-panel__title">${title}</h3>

        <div class="pcd-multibuy-panel__progress-row">
          <div
            class="pcd-multibuy-panel__track"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="2"
            aria-valuenow="${Math.min(treatsCount, 2)}"
            aria-label="Jars multibuy progress"
          >
            <span
              class="pcd-multibuy-panel__fill"
              style="width: ${visualProgress}%;"
            ></span>
          </div>

          <span class="pcd-multibuy-panel__remaining">${remainingLabel}</span>
        </div>

        <p class="pcd-multibuy-panel__saving">${savingMessage}</p>
      </section>
    `;
  }

  renderTreatCrossSells(cart, products) {
    if (!Array.isArray(products) || products.length === 0) return '';

    const currentProductHandle = this.getCurrentProductHandle();
    const fallbackCartTreat = (cart.items || []).find(
      (item) => item.product_type === 'Dog Treats'
    );

    // On a product page, always place that page's product first. If this
    // drawer is opened elsewhere, fall back to the first Dog Treats item
    // already in the basket.
    const orderedProducts = this.orderTreatProducts(
      products,
      currentProductHandle,
      fallbackCartTreat
    );

    const hasUnlockedMultibuy = this.getTreatCount(cart) >= 2;

    // Use the flavour of the first Dog Treat line in the basket as the
    // default flavour for every other treat, where that flavour is available.
    const preferredFlavourTitle = fallbackCartTreat
      ? this.normaliseVariantTitle(fallbackCartTreat.variant_title)
      : '';

    const cards = orderedProducts.map((product, index) => {
      const matchingCartTreat = (cart.items || []).find(
        (item) => Number(item.product_id) === Number(product.id)
      ) || null;

      return this.renderTreatCard(product, matchingCartTreat, {
        isFirst: index === 0,
        hasUnlockedMultibuy,
        preferredFlavourTitle
      });
    }).join('');

    return `
      <p class="pcd-cross-sell-intro">
        Mix and match our treats - they’re specially formulated to work together.
      </p>

      <div class="pcd-treat-grid">
        ${cards}
      </div>
    `;
  }

  renderTreatCard(
    product,
    cartTreat,
    {
      isFirst = false,
      hasUnlockedMultibuy = false,
      preferredFlavourTitle = ''
    } = {}
  ) {
    const isSameAsBasket = Boolean(
      cartTreat && Number(cartTreat.product_id) === Number(product.id)
    );

    // Prefer the exact flavour already in the basket for the first/current
    // product, then remove duplicate flavour labels caused by invisible
    // Unicode characters in some variant titles.
    const basketVariant = isSameAsBasket
      ? (product.variants || []).find(
          (candidate) => Number(candidate.id) === Number(cartTreat.variant_id)
        )
      : null;

    const preferredFlavourKey = this.normaliseVariantTitle(
      preferredFlavourTitle
    ).toLocaleLowerCase('en-GB');

    const matchingPreferredFlavour = !isSameAsBasket && preferredFlavourTitle
      ? (product.variants || []).find((candidate) =>
          candidate &&
          candidate.available !== false &&
          this.normaliseVariantTitle(candidate.title)
            .toLocaleLowerCase('en-GB') === preferredFlavourKey
        )
      : null;

    const initialVariant = basketVariant ||
      matchingPreferredFlavour ||
      this.getFirstAvailableVariant(product);
    const flavourVariants = this.getSelectableFlavourVariants(
      product,
      initialVariant?.id
    );

    const variant = flavourVariants.find(
      (candidate) => Number(candidate.id) === Number(initialVariant?.id)
    ) || flavourVariants[0];

    if (!variant) return '';

    const display = this.getTreatDisplayCopy(product);
    const productUrl = `${this.getShopifyRoot()}products/${encodeURIComponent(product.handle)}?variant=${Number(variant.id)}`;
    const variantImageUrl = this.normaliseImageUrl(
      variant.image || variant.featured_image || variant.featuredImage
    );
    const imageUrl = isSameAsBasket && cartTreat.image
      ? cartTreat.image
      : (variantImageUrl || this.getProductImageUrl(product));
    // Any product already present in the basket uses "Add another".
    // Products not yet in the basket use the normal add-to-basket wording.
    const buttonText = isSameAsBasket
      ? 'Add another'
      : 'Add to basket';

    const flavourOptions = flavourVariants.map((candidate) => {
      const flavourName = this.normaliseVariantTitle(candidate.title);
      const candidateImageUrl = this.normaliseImageUrl(
        candidate.image || candidate.featured_image || candidate.featuredImage
      );
      const isSelected = Number(candidate.id) === Number(variant.id);

      return `
        <option
          value="${Number(candidate.id)}"
          data-variant-image="${this.escapeHtml(candidateImageUrl)}"
          ${isSelected ? 'selected' : ''}
        >
          ${this.escapeHtml(flavourName)}
        </option>
      `;
    }).join('');

    return `
      <article class="pcd-treat-card" data-cross-sell-product-id="${Number(product.id)}">
        <a
          class="pcd-treat-card__image-link"
          href="${this.escapeHtml(productUrl)}"
          aria-label="View ${this.escapeHtml(product.title)}"
        >
          ${imageUrl
            ? `<img class="pcd-treat-card__image" src="${this.escapeHtml(this.resizeImageUrl(imageUrl, 240))}" alt="${this.escapeHtml(product.title)}" loading="lazy">`
            : ''}
        </a>

        ${this.renderProductShortSynopsis(product, display)}

        <div class="pcd-treat-card__split-button ${isFirst ? 'pcd-treat-card__split-button--primary' : ''}">
          <button
            type="button"
            class="pcd-treat-card__button"
            data-add-treat-variant="${Number(variant.id)}"
            data-add-treat-product-title="${this.escapeHtml(product.title)}"
          >
            ${buttonText}
          </button>

          <label
            class="pcd-treat-card__flavour"
            title="Choose flavour"
          >
            <select
              class="pcd-treat-card__flavour-select"
              data-treat-flavour-select
              aria-label="Choose flavour for ${this.escapeHtml(product.title)}"
            >
              ${flavourOptions}
            </select>
          </label>
        </div>

        <details class="pcd-treat-card__details">
          <summary>More info</summary>
          ${this.renderTreatMoreInfo(product)}
        </details>
      </article>
    `;
  }

  getSelectableFlavourVariants(product, preferredVariantId = null) {
    const variants = Array.isArray(product?.variants)
      ? product.variants.filter((variant) => variant && variant.available !== false)
      : [];

    const uniqueVariants = new Map();

    variants.forEach((variant) => {
      const title = this.normaliseVariantTitle(variant.title);
      const key = title.toLocaleLowerCase('en-GB');
      const existing = uniqueVariants.get(key);
      const isPreferred = Number(variant.id) === Number(preferredVariantId);

      if (!existing || isPreferred) {
        uniqueVariants.set(key, {
          ...variant,
          title
        });
      }
    });

    return [...uniqueVariants.values()];
  }

  normaliseVariantTitle(value) {
    const title = String(value || '')
      // Remove direction marks, word joiners and other invisible formatting
      // characters that have produced duplicate Salmon/Chicken/Pork variants.
      .replace(/[\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    return title && title !== 'Default Title'
      ? title
      : 'Standard';
  }

  getMultibuyDiscountRate() {
    const decimalRate = Number(window.multibuyDiscountPercent);

    if (!Number.isFinite(decimalRate) || decimalRate <= 0 || decimalRate >= 1) {
      return null;
    }

    return decimalRate;
  }

  getProspectiveMultibuySavingCents(cart, products = []) {
    const discountRate = this.getMultibuyDiscountRate();
    if (discountRate === null) return null;

    const treatItems = (cart.items || []).filter(
      (item) => item.product_type === 'Dog Treats'
    );

    const treatsCount = treatItems.reduce(
      (total, item) => total + Number(item.quantity || 0),
      0
    );

    const missingTreats = Math.max(2 - treatsCount, 0);
    if (missingTreats === 0) return 0;

    // Use original line totals so this estimates the saving before the
    // multibuy discount is applied.
    const currentTreatSubtotal = treatItems.reduce((total, item) => {
      const lineTotal = Number(
        item.original_line_price ?? item.final_line_price ?? item.line_price ?? 0
      );

      return total + Math.max(lineTotal, 0);
    }, 0);

    const availableVariantPrices = (products || [])
      .flatMap((product) => Array.isArray(product.variants) ? product.variants : [])
      .filter((variant) => variant && variant.available !== false)
      .map((variant) => Number(variant.price))
      .filter((price) => Number.isFinite(price) && price > 0);

    // All current treat jars are the same price. Taking the lowest available
    // price also prevents the UI from overstating the saving if prices diverge.
    let addedTreatPrice = availableVariantPrices.length
      ? Math.min(...availableVariantPrices)
      : null;

    // Fallback to the current basket treat's original unit price if product
    // data has not loaded or contains no available variant price.
    if (addedTreatPrice === null && treatItems.length) {
      const item = treatItems[0];
      const quantity = Math.max(Number(item.quantity || 0), 1);
      const lineTotal = Number(
        item.original_line_price ?? item.final_line_price ?? item.line_price ?? 0
      );

      if (Number.isFinite(lineTotal) && lineTotal > 0) {
        addedTreatPrice = lineTotal / quantity;
      }
    }

    if (!Number.isFinite(addedTreatPrice) || addedTreatPrice <= 0) {
      return null;
    }

    const qualifyingSubtotal = currentTreatSubtotal + (addedTreatPrice * missingTreats);

    // Floor to whole pennies. This preserves the earlier display convention:
    // £39.98 × 10% = £3.99, while £39.98 × 20% = £7.99.
    return Math.round((qualifyingSubtotal * discountRate) + 1e-9);
  }

  getMultibuyDiscountPercent() {
    const decimalRate = this.getMultibuyDiscountRate();

    if (decimalRate === null) {
      return null;
    }

    // window.multibuyDiscountPercent is supplied as a decimal:
    // 0.10 => 10, 0.075 => 7.5.
    return decimalRate * 100;
  }

  getMultibuyDiscountLabel() {
    const percent = this.getMultibuyDiscountPercent();

    if (percent === null) {
      return null;
    }

    return `${percent.toLocaleString('en-GB', {
      maximumFractionDigits: 0
    })}%`;
  }

  getTreatDisplayCopy(product) {
    const title = String(product.title || '').toLowerCase();

    const mappings = [
      {
        matches: ['stop bloody scratching'],
        functionTitle: 'Itching treats',
        summary: 'Helps soothe itching and support healthy skin.'
      },
      {
        matches: ['calm the eff down'],
        functionTitle: 'Calming treats',
        summary: 'Helps reduce stress, anxiety and hyperactivity.'
      },
      {
        matches: ['get bloody moving'],
        functionTitle: 'Mobility treats',
        summary: 'Supports joint health, mobility and flexibility.'
      },
      {
        matches: ['stop blooming farting'],
        functionTitle: 'Digestive treats',
        summary: 'Supports healthy digestion and reduces tummy troubles.'
      },
      {
        matches: ['stop bloody licking'],
        functionTitle: 'Skin & allergy treats',
        summary: 'Supports skin health and soothes irritation.'
      },
      {
        matches: ['calm & relax', 'calm and relax'],
        functionTitle: 'Relaxation treats',
        summary: 'Helps calm anxious dogs and promotes relaxation.'
      }
    ];

    const match = mappings.find((mapping) =>
      mapping.matches.some((needle) => title.includes(needle))
    );

    return match || {
      functionTitle: 'Herbal dog treats',
      summary: this.truncateText(this.stripHtml(product.body_html || ''), 105) ||
        'A complementary herbal treat for your dog.'
    };
  }

  renderProductShortSynopsis(product, fallbackDisplay) {
    const synopsis = this.getProductShortSynopsis(product);

    if (!synopsis) {
      return `
        <div style="min-height:74px;color:#111827;">
          <h4 style="margin:0 0 5px;font-size:14px;font-weight:800;line-height:1.2;">
            ${this.escapeHtml(fallbackDisplay.functionTitle)}
          </h4>
          <p style="margin:0;font-size:12px;line-height:1.35;">
            ${this.escapeHtml(fallbackDisplay.summary)}
          </p>
        </div>
      `;
    }

    const html = this.looksLikeHtml(synopsis)
      ? this.styleShortSynopsisHtml(this.sanitiseStoreHtml(synopsis))
      : `<p style="margin:0;font-size:12px;line-height:1.35;">${this.escapeHtml(synopsis)}</p>`;

    return `
      <div style="min-height:74px;color:#111827;">
        ${html}
      </div>
    `;
  }

  styleShortSynopsisHtml(html) {
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
    const root = doc.body.firstElementChild;

    if (!root) return html;

    root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
      heading.setAttribute(
        'style',
        'margin:0 0 5px;font-size:14px;font-weight:800;line-height:1.2;color:#111827;'
      );
    });

    root.querySelectorAll('p').forEach((paragraph) => {
      paragraph.setAttribute(
        'style',
        'margin:0;font-size:12px;line-height:1.35;color:#111827;'
      );
    });

    root.querySelectorAll('ul, ol').forEach((list) => {
      list.setAttribute(
        'style',
        'margin:0;padding-left:17px;font-size:12px;line-height:1.35;color:#111827;'
      );
    });

    root.querySelectorAll('li').forEach((item) => {
      item.setAttribute('style', 'margin:0 0 3px;');
    });

    return root.innerHTML;
  }

  renderTreatMoreInfo(product) {
    // Show every benefit supplied by the product metafield. Ingredients stay
    // on the full product page to keep the basket drawer compact.
    const benefits = this.getProductKeyBenefits(product);
    const productUrl = `${this.getShopifyRoot()}products/${encodeURIComponent(product.handle)}`;

    const benefitsHtml = benefits.length
      ? `
        <section style="margin:0;">
          <h5 style="margin:0 0 7px;color:#111827;font-size:13px;font-weight:900;line-height:1.2;">
            Key Benefits
          </h5>
          <ul style="margin:0;padding-left:16px;color:#1f2937;font-size:12px;line-height:1.4;">
            ${benefits.map((benefit) => `
              <li style="margin:0 0 4px;list-style:disc;">${this.escapeHtml(benefit)}</li>
            `).join('')}
          </ul>
        </section>
      `
      : '<p style="margin:0;color:#6b7280;font-size:12px;line-height:1.4;">More product information is available on the product page.</p>';

    return `
      <div style="padding:9px 2px 5px;color:#4b5563;">
        ${benefitsHtml}

        <a
          href="${this.escapeHtml(productUrl)}"
          style="
            display:inline-flex;
            align-items:center;
            gap:5px;
            margin-top:10px;
            color:#15803d;
            font-size:12px;
            font-weight:800;
            line-height:1.2;
            text-decoration:underline;
            text-underline-offset:2px;
          "
        >
          Read more <span aria-hidden="true">→</span>
        </a>
      </div>
    `;
  }

  getProductShortSynopsis(product) {
    const custom = this.getCustomMetafields(product);
    const candidates = [
      product.shortSynopsisHtml,
      product.short_synopsis_html,
      product.short_synopsis,
      product.shortSynopsis,
      custom.short_synopsis_html,
      custom.shortSynopsisHtml,
      custom.short_synopsis,
      custom.shortSynopsis,
      this.findDeepValueByKeys(product, [
        'short_synopsis_html',
        'shortSynopsisHtml',
        'short_synopsis',
        'shortSynopsis'
      ])
    ];

    for (const candidate of candidates) {
      const synopsis = this.normaliseSynopsis(candidate);
      if (synopsis) return synopsis;
    }

    return '';
  }

  getProductKeyBenefits(product) {
    const custom = this.getCustomMetafields(product);
    const candidates = [
      product.keyBenefits,
      product.key_benefits,
      product.summary?.bullets,
      product.summary?.value?.bullets,
      product.summary?.bullets?.value,
      product.summary?.value?.bullets?.value,
      custom.key_benefits,
      custom.keyBenefits,
      custom.summary?.bullets,
      custom.summary?.value?.bullets,
      custom.summary?.bullets?.value,
      custom.summary?.value?.bullets?.value,
      this.findDeepValueByKeys(product, ['key_benefits', 'keyBenefits']),
      this.findDeepValueByKeys(product, ['bullets'])
    ];

    for (const candidate of candidates) {
      const benefits = this.normaliseTextList(candidate);
      if (benefits.length) return benefits;
    }

    return [];
  }

  getProductKeyIngredients(product) {
    const custom = this.getCustomMetafields(product);
    const candidates = [
      product.keyIngredients,
      product.key_ingredients,
      custom.key_ingredients,
      custom.keyIngredients,
      this.findDeepValueByKeys(product, ['key_ingredients', 'keyIngredients'])
    ];

    for (const candidate of candidates) {
      const entries = this.coerceArray(candidate);
      if (!entries.length) continue;

      const ingredients = entries
        .map((entry) => this.normaliseIngredient(entry))
        .filter((entry) => entry.name || entry.summary || entry.image);

      if (ingredients.length) return ingredients;
    }

    return [];
  }

  getCustomMetafields(product) {
    return product?.metafields?.custom ||
      product?.custom_metafields ||
      product?.customMetafields ||
      {};
  }

  normaliseSynopsis(input) {
    const value = this.unwrapMetafieldValue(input);

    if (value === null || typeof value === 'undefined') return '';

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return '';

      // Rich-text metafields are sometimes emitted as JSON strings.
      if (
        (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
        (trimmed.startsWith('[') && trimmed.endsWith(']'))
      ) {
        try {
          return this.normaliseSynopsis(JSON.parse(trimmed));
        } catch (_) {
          // It is a normal string, not JSON.
        }
      }

      return trimmed;
    }

    if (Array.isArray(value)) {
      return value
        .map((entry) => this.normaliseSynopsis(entry))
        .filter(Boolean)
        .join('');
    }

    if (typeof value === 'object') {
      const explicitHtml = value.html || value.html_value || value.rendered_html;
      if (typeof explicitHtml === 'string' && explicitHtml.trim()) {
        return explicitHtml.trim();
      }

      if (value.type === 'root' || Array.isArray(value.children)) {
        return this.richTextNodeToHtml(value);
      }

      const nested = this.findDeepValueByKeys(value, [
        'short_synopsis_html',
        'shortSynopsisHtml',
        'short_synopsis',
        'shortSynopsis',
        'html'
      ]);

      if (nested && nested !== value) {
        return this.normaliseSynopsis(nested);
      }

      const text = this.extractTextValue(value);
      return text.trim();
    }

    return String(value).trim();
  }

  normaliseTextList(input) {
    const value = this.unwrapMetafieldValue(input);

    if (value === null || typeof value === 'undefined' || value === '') {
      return [];
    }

    if (Array.isArray(value)) {
      return value
        .flatMap((entry) => this.normaliseTextList(entry))
        .map((entry) => entry.trim())
        .filter(Boolean);
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return [];

      if (
        (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
        (trimmed.startsWith('[') && trimmed.endsWith(']'))
      ) {
        try {
          return this.normaliseTextList(JSON.parse(trimmed));
        } catch (_) {
          // Continue as plain text.
        }
      }

      return [this.stripHtml(trimmed).trim()].filter(Boolean);
    }

    if (typeof value === 'object') {
      if (Array.isArray(value.nodes)) {
        return this.normaliseTextList(value.nodes);
      }

      if (Array.isArray(value.edges)) {
        return this.normaliseTextList(value.edges.map((edge) => edge?.node));
      }

      const nestedList = value.bullets ||
        value.items ||
        value.list ||
        value.values ||
        value.references?.nodes;

      if (nestedList) return this.normaliseTextList(nestedList);

      if (value.type === 'root' || Array.isArray(value.children)) {
        const listItems = [];
        this.collectRichTextListItems(value, listItems);
        if (listItems.length) return listItems;
      }

      const text = this.extractTextValue(value).trim();
      return text ? [text] : [];
    }

    return [String(value).trim()].filter(Boolean);
  }

  normaliseIngredient(entry) {
    let ingredient = this.unwrapMetafieldValue(entry);

    if (!ingredient || typeof ingredient !== 'object') {
      return { name: '', summary: '', image: null };
    }

    // Storefront API metaobjects can arrive as fields: [{ key, value, reference }].
    if (Array.isArray(ingredient.fields)) {
      ingredient = ingredient.fields.reduce((result, field) => {
        if (!field?.key) return result;
        result[field.key] = field.reference || field.value;
        return result;
      }, { ...ingredient });
    }

    const nameValue = ingredient.name ??
      ingredient.title ??
      this.findDeepValueByKeys(ingredient, ['name', 'title']);

    const summaryValue = ingredient.summary ??
      ingredient.description ??
      this.findDeepValueByKeys(ingredient, ['summary', 'description']);

    const imageValue = ingredient.image ??
      ingredient.image_url ??
      ingredient.imageUrl ??
      ingredient.photo ??
      this.findDeepValueByKeys(ingredient, [
        'image',
        'image_url',
        'imageUrl',
        'photo'
      ]);

    return {
      name: this.extractTextValue(nameValue).trim(),
      summary: this.extractTextValue(summaryValue).trim(),
      image: this.unwrapMetafieldValue(imageValue) || null
    };
  }

  getIngredientImageUrl(image) {
    const value = this.unwrapMetafieldValue(image);

    if (typeof value === 'string') return value;
    if (!value || typeof value !== 'object') return '';

    return value.url ||
      value.src ||
      value.image_url ||
      value.imageUrl ||
      value.originalSrc ||
      value.preview_image?.src ||
      value.preview_image?.url ||
      value.previewImage?.src ||
      value.previewImage?.url ||
      value.image?.url ||
      value.image?.src ||
      value.reference?.image?.url ||
      value.reference?.previewImage?.url ||
      '';
  }

  unwrapMetafieldValue(input) {
    let value = input;
    const seen = new Set();

    while (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      !seen.has(value)
    ) {
      seen.add(value);

      if (Object.prototype.hasOwnProperty.call(value, 'value')) {
        value = value.value;
        continue;
      }

      if (Object.prototype.hasOwnProperty.call(value, 'reference')) {
        value = value.reference;
        continue;
      }

      break;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();

      if (
        (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
        (trimmed.startsWith('{') && trimmed.endsWith('}'))
      ) {
        try {
          return JSON.parse(trimmed);
        } catch (_) {
          return value;
        }
      }
    }

    return value;
  }

  coerceArray(input) {
    const value = this.unwrapMetafieldValue(input);

    if (Array.isArray(value)) return value;
    if (value === null || typeof value === 'undefined' || value === '') return [];

    if (typeof value === 'object') {
      if (Array.isArray(value.nodes)) return value.nodes;
      if (Array.isArray(value.edges)) return value.edges.map((edge) => edge?.node).filter(Boolean);
      if (Array.isArray(value.references?.nodes)) return value.references.nodes;
      if (Array.isArray(value.items)) return value.items;
    }

    return [value];
  }

  findDeepValueByKeys(input, keys, maxDepth = 12) {
    const wanted = new Set(keys);
    const seen = new Set();

    const visit = (value, depth) => {
      if (!value || typeof value !== 'object' || depth > maxDepth || seen.has(value)) {
        return undefined;
      }

      seen.add(value);

      if (!Array.isArray(value)) {
        for (const key of keys) {
          if (
            Object.prototype.hasOwnProperty.call(value, key) &&
            value[key] !== null &&
            typeof value[key] !== 'undefined' &&
            value[key] !== ''
          ) {
            return value[key];
          }
        }
      }

      const children = Array.isArray(value) ? value : Object.values(value);

      for (const child of children) {
        const result = visit(child, depth + 1);
        if (typeof result !== 'undefined') return result;
      }

      return undefined;
    };

    return visit(input, 0);
  }

  extractTextValue(input) {
    const value = this.unwrapMetafieldValue(input);

    if (value === null || typeof value === 'undefined') return '';
    if (typeof value === 'string') return this.stripHtml(value);
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);

    if (Array.isArray(value)) {
      return value
        .map((entry) => this.extractTextValue(entry))
        .filter(Boolean)
        .join(' ');
    }

    if (typeof value === 'object') {
      if (typeof value.text === 'string') return value.text;
      if (typeof value.value === 'string') return this.stripHtml(value.value);
      if (typeof value.name === 'string') return value.name;

      if (Array.isArray(value.children)) {
        return value.children
          .map((child) => this.extractTextValue(child))
          .filter(Boolean)
          .join(' ')
          .replace(/\s+/g, ' ');
      }
    }

    return '';
  }

  collectRichTextListItems(node, output) {
    if (!node || typeof node !== 'object') return;

    const type = String(node.type || '').toLowerCase();

    if (type === 'list-item' || type === 'list_item') {
      const text = this.extractTextValue(node).trim();
      if (text) output.push(text);
      return;
    }

    if (Array.isArray(node.children)) {
      node.children.forEach((child) => this.collectRichTextListItems(child, output));
    }
  }

  richTextNodeToHtml(node) {
    if (!node || typeof node !== 'object') return '';

    if (Array.isArray(node)) {
      return node.map((child) => this.richTextNodeToHtml(child)).join('');
    }

    const children = Array.isArray(node.children)
      ? node.children.map((child) => this.richTextNodeToHtml(child)).join('')
      : '';

    const type = String(node.type || '').toLowerCase();

    if (type === 'text') {
      let text = this.escapeHtml(node.value ?? node.text ?? '');
      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;
      return text;
    }

    switch (type) {
      case 'root':
        return children;
      case 'paragraph':
        return `<p>${children}</p>`;
      case 'heading': {
        const level = Math.min(6, Math.max(2, Number(node.level) || 3));
        return `<h${level}>${children}</h${level}>`;
      }
      case 'list':
        return node.listType === 'ordered'
          ? `<ol>${children}</ol>`
          : `<ul>${children}</ul>`;
      case 'list-item':
      case 'list_item':
        return `<li>${children}</li>`;
      case 'link': {
        const href = this.escapeHtml(node.url || node.href || '#');
        return `<a href="${href}">${children}</a>`;
      }
      case 'strong':
      case 'bold':
        return `<strong>${children}</strong>`;
      case 'em':
      case 'italic':
        return `<em>${children}</em>`;
      case 'line-break':
      case 'line_break':
        return '<br>';
      default:
        return children || this.escapeHtml(node.value ?? node.text ?? '');
    }
  }

  looksLikeHtml(value) {
    return /<[^>]+>/.test(String(value || ''));
  }

  sanitiseStoreHtml(value) {
    const template = document.createElement('template');
    template.innerHTML = String(value || '');

    template.content
      .querySelectorAll('script, style, iframe, object, embed')
      .forEach((element) => element.remove());

    template.content.querySelectorAll('*').forEach((element) => {
      [...element.attributes].forEach((attribute) => {
        if (/^on/i.test(attribute.name) || attribute.name === 'srcdoc') {
          element.removeAttribute(attribute.name);
        }
      });
    });

    return template.innerHTML;
  }

  orderTreatProducts(products, currentProductHandle = '', fallbackCartTreat = null) {
    const availableTreats = products.filter((product) =>
      product &&
      product.product_type === 'Dog Treats' &&
      this.getFirstAvailableVariant(product)
    );

    const normalisedCurrentHandle = this.normaliseProductHandle(currentProductHandle);
    const hasCurrentPageProduct = Boolean(
      normalisedCurrentHandle &&
      availableTreats.some(
        (product) => this.normaliseProductHandle(product.handle) === normalisedCurrentHandle
      )
    );

    const fallbackProductId = hasCurrentPageProduct
      ? null
      : Number(fallbackCartTreat?.product_id || 0);

    if (!hasCurrentPageProduct && !fallbackProductId) {
      return availableTreats;
    }

    return [...availableTreats].sort((a, b) => {
      const aMatches = hasCurrentPageProduct
        ? this.normaliseProductHandle(a.handle) === normalisedCurrentHandle
        : Number(a.id) === fallbackProductId;
      const bMatches = hasCurrentPageProduct
        ? this.normaliseProductHandle(b.handle) === normalisedCurrentHandle
        : Number(b.id) === fallbackProductId;

      if (aMatches === bMatches) return 0;
      return aMatches ? -1 : 1;
    });
  }

  getCurrentProductHandle() {
    const extractHandle = (value) => {
      if (!value) return '';

      try {
        const url = new URL(value, window.location.origin);
        const match = url.pathname.match(/(?:^|\/)products\/([^/?#]+)/i);
        return match ? this.normaliseProductHandle(decodeURIComponent(match[1])) : '';
      } catch (_) {
        const match = String(value).match(/(?:^|\/)products\/([^/?#]+)/i);
        return match ? this.normaliseProductHandle(decodeURIComponent(match[1])) : '';
      }
    };

    const fromCurrentUrl = extractHandle(window.location.href);
    if (fromCurrentUrl) return fromCurrentUrl;

    const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href;
    return extractHandle(canonicalUrl);
  }

  normaliseProductHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^\/+|\/+$/g, '')
      .toLowerCase();
  }

  getFirstAvailableVariant(product) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.find((variant) => variant.available !== false) || null;
  }

  getProductImageUrl(product) {
    const featuredImageUrl = this.normaliseImageUrl(
      product.featured_image || product.featuredImage || product.image
    );

    if (featuredImageUrl) return featuredImageUrl;

    if (Array.isArray(product.images) && product.images.length > 0) {
      const firstImageUrl = this.normaliseImageUrl(product.images[0]);
      if (firstImageUrl) return firstImageUrl;
    }

    const variants = Array.isArray(product.variants) ? product.variants : [];
    for (const variant of variants) {
      const variantImageUrl = this.normaliseImageUrl(
        variant.image || variant.featured_image || variant.featuredImage
      );
      if (variantImageUrl) return variantImageUrl;
    }

    return '';
  }

  normaliseImageUrl(image) {
    if (!image) return '';

    if (typeof image === 'string') {
      return image.trim();
    }

    if (typeof image !== 'object') return '';

    const directUrl =
      image.url ||
      image.src ||
      image.originalSrc ||
      image.original_url ||
      image.originalUrl;

    if (typeof directUrl === 'string' && directUrl.trim()) {
      return directUrl.trim();
    }

    return this.normaliseImageUrl(
      image.preview_image ||
      image.previewImage ||
      image.image
    );
  }

  getTreatCount(cart) {
    return (cart.items || [])
      .filter((item) => item.product_type === 'Dog Treats')
      .reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );
  }

  async fetchTreatProducts() {
    if (!this.treatProductsPromise) {
      this.treatProductsPromise = Promise.resolve().then(() => {
        const dataElement = document.getElementById('data-dog-treat-products');

        if (!dataElement) {
          throw new Error('Missing #data-dog-treat-products JSON element');
        }

        const rawJson = dataElement.textContent.trim();

        if (!rawJson) {
          throw new Error('#data-dog-treat-products is empty');
        }

        let data;

        try {
          data = JSON.parse(rawJson);
        } catch (error) {
          throw new Error(`#data-dog-treat-products contains invalid JSON: ${error.message}`);
        }

        const products = Array.isArray(data)
          ? data
          : (Array.isArray(data.products) ? data.products : []);

        return products.map((product) => this.normaliseTreatProduct(product));
      }).catch((error) => {
        // Permit a later retry if Liquid data is inserted after the first attempt.
        this.treatProductsPromise = null;
        throw error;
      });
    }

    return this.treatProductsPromise;
  }

  normaliseTreatProduct(product) {
    const variants = Array.isArray(product?.variants)
      ? product.variants.map((variant) => ({
          ...variant,
          id: variant.id ?? variant.variant_id,
          available: variant.available !== false
        }))
      : [];

    return {
      ...product,
      id: product.id ?? product.product_id,
      title: product.title || product.product_title || '',
      handle: product.handle || '',
      product_type: product.product_type || product.productType || product.type || '',
      featured_image: product.featured_image || product.featuredImage || product.image || '',
      variants
    };
  }

  onCartNotificationChange(event) {
    const flavourSelect = event.target.closest('[data-treat-flavour-select]');
    if (!flavourSelect) return;

    const variantId = Number(flavourSelect.value);
    if (!variantId) return;

    const card = flavourSelect.closest('.pcd-treat-card');
    if (!card) return;

    const addButton = card.querySelector('[data-add-treat-variant]');
    if (addButton) {
      addButton.dataset.addTreatVariant = String(variantId);
    }

    const productLink = card.querySelector('.pcd-treat-card__image-link');
    if (productLink) {
      try {
        const url = new URL(productLink.href, window.location.origin);
        url.searchParams.set('variant', String(variantId));
        productLink.href = url.toString();
      } catch (_) {
        // The add action still works even if the product link cannot be updated.
      }
    }

    const selectedOption = flavourSelect.selectedOptions?.[0];
    const selectedImage = selectedOption?.dataset.variantImage;
    const image = card.querySelector('.pcd-treat-card__image');

    if (selectedImage && image) {
      image.src = this.resizeImageUrl(selectedImage, 240);
    }
  }

  async onCartNotificationClick(event) {
    const addButton = event.target.closest('[data-add-treat-variant]');

    if (addButton) {
      event.preventDefault();
      await this.handleTreatAdd(addButton);
      return;
    }

    const quantityButton = event.target.closest(
      '[data-cart-qty-minus], [data-cart-qty-plus]'
    );

    if (!quantityButton) return;

    event.preventDefault();

    const line = Number(quantityButton.dataset.line);
    const quantity = Number(quantityButton.dataset.quantity);

    if (!line || quantity < 0) return;

    this.setLineLoading(line, true);

    this.querySelectorAll(`[data-line="${line}"]`).forEach((button) => {
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
    });

    try {
      await this.changeCartLineQuantity(line, quantity);
      await this.refreshFullCartNotification();
    } catch (error) {
      console.error('Failed to update cart quantity', error);
      this.setLineLoading(line, false);

      this.querySelectorAll(`[data-line="${line}"]`).forEach((button) => {
        button.removeAttribute('aria-disabled');
        button.disabled = false;
      });
    }
  }

  async handleTreatAdd(button) {
    const variantId = Number(button.dataset.addTreatVariant);
    if (!variantId || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Adding…';

    try {
      await this.addVariantToCart(variantId, 1);
      await this.refreshFullCartNotification();
    } catch (error) {
      console.error('Failed to add cross-sell product', error);
      button.textContent = 'Try again';
      button.disabled = false;
      button.removeAttribute('aria-disabled');

      window.setTimeout(() => {
        if (button.isConnected) button.textContent = originalText;
      }, 1800);
    }
  }

  async addVariantToCart(variantId, quantity = 1) {
    const response = await fetch(`${this.getShopifyRoot()}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity
          }
        ]
      })
    });

    if (!response.ok) {
      let message = `Cart add failed with status ${response.status}`;

      try {
        const errorData = await response.json();
        message = errorData.description || errorData.message || message;
      } catch (_) {
        // Keep the status-based message if Shopify did not return JSON.
      }

      throw new Error(message);
    }

    return response.json();
  }

  async changeCartLineQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname
    });

    const response = await fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body
    });

    if (!response.ok) {
      throw new Error(`Cart change failed with status ${response.status}`);
    }

    return response.json();
  }

  async refreshFullCartNotification() {
    const cart = await this.fetchCart();

    await this.renderFullCartItems(cart);
    this.updatePriceElements(cart);

    const sectionResponse = await fetch(
      `${window.location.pathname}?sections=cart-icon-bubble`
    );

    if (!sectionResponse.ok) return;

    const sections = await sectionResponse.json();

    if (sections['cart-icon-bubble']) {
      const cartBubble = document.getElementById('cart-icon-bubble');

      if (cartBubble) {
        cartBubble.innerHTML = this.getSectionInnerHTML(
          sections['cart-icon-bubble'],
          '.shopify-section'
        );
      }
    }
  }

  renderPrice() {
    this.fetchCart()
      .then((cart) => {
        this.updatePriceElements(cart);
      })
      .catch((error) => {
        console.error('Failed to refresh cart price', error);
      });
  }

  async renderPriceFromCart() {
    const cart = await this.fetchCart();
    this.updatePriceElements(cart);
  }

  updatePriceElements(cart) {
    document.querySelectorAll('.pcd-cart-subtotal').forEach((element) => {
      element.innerHTML = this.formatMoney(cart.total_price);
    });
  }

  async fetchCart() {
    const response = await fetch(`${this.getShopifyRoot()}cart.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Cart fetch failed with status ${response.status}`);
    }

    return response.json();
  }

  getShopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  resizeImageUrl(url, width) {
    if (!url) return '';

    try {
      const parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (_) {
      const separator = String(url).includes('?') ? '&' : '?';
      return `${url}${separator}width=${encodeURIComponent(width)}`;
    }
  }

  stripHtml(value) {
    const doc = new DOMParser().parseFromString(String(value || ''), 'text/html');
    return (doc.body.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  truncateText(value, maxLength) {
    const text = String(value || '').trim();
    if (text.length <= maxLength) return text;
    return `${text.slice(0, Math.max(0, maxLength - 1)).trim()}…`;
  }

  formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }

    return (Number(cents) / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP'
    });
  }

  getCartItemKey(parsedState) {
    if (parsedState.key) {
      return parsedState.key;
    }

    const htmlString = parsedState.sections['cart-notification-product'];
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const firstCartItem = doc.querySelector('.cart-item');

    return firstCartItem.id.replace('cart-notification-product-', '');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const selected = parsed.querySelector(selector);

    return selected ? selected.innerHTML : html;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}

customElements.define('cart-notification', CartNotification);